module.exports = __webpack_public_path__ + "images/4-sim-serial-a.fcc59ce14b1aac574931e3797212b207.png";